import {
  Component,
  OnInit,
  ViewChild,
  Inject,
  OnDestroy,
  HostListener,
  ViewChildren,
  AfterViewInit
} from '@angular/core';
import {NgForm} from '@angular/forms';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Message} from 'src/app/core/class/message';
import {ServiceTypeService} from 'src/app/core/services/service-type.service';
import {ToastrService} from 'ngx-toastr';
import {Subscription, Subject} from 'rxjs';
import {MatOption, MatSelect} from '@angular/material';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-add-document-group',
  templateUrl: './add-document-group.component.html',
  styleUrls: ['./add-document-group.component.scss']
})
export class AddDocumentGroupComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(
    private dialog: MatDialog,
    private message: Message,
    public dialogRef: MatDialogRef<AddDocumentGroupComponent>,
    public serviceTypeService: ServiceTypeService,
    private toastr: ToastrService,
    public commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onBtnCancelClick();
    });

    if (data.serviceType) {
      this.documents = data.serviceType;
      if (this.documents.isOnPromptToSign) {
        this.isOnRemindSignContract = true;
      }
      if (data.serviceType.sendInternalSign) {
        this.documents.sendInternalSign = data.serviceType.sendInternalSign.split(',');
      }
      if (data.serviceType.sendSMSInternalInFlow) {
        this.documents.sendSMSInternalInFlow = data.serviceType.sendSMSInternalInFlow.split(',');
      }
      // console.log(this.documents)
    }
  }
  isOnRemindSignContract = false;

  @ViewChild('f', {static: false}) ngForm: NgForm;
  @ViewChildren('focusInput') focusInput;
  @ViewChildren('focusCode') focusCode;
  // @ts-ignore
  @ViewChild('select') select: MatSelect;
  createSuccess = new Subject();

  success = false;
  isFormChanging = false;
  isCheck = false;
  isClick = false;
  isCheckInternal = false;
  isCheckSendSMSInFlow = false;
  isClickSendSMSInFlow = false;
  isCheckSendSMSInternalInFlow = false;
  private checkEscKey: boolean;
  private show: boolean;
  documents = new Document();
  formChangesSubscription: Subscription;

  // allSelected = false;
  internalObjects: any[] = [
    {value: '1', viewValue: 'search_form.signer'},
    {value: '2', viewValue: 'search_form.approver'},
    {value: '3', viewValue: 'search_form.initialer'},
  ];

  internalObjectsToSendSMS: any[] = [
    {value: '1', viewValue: 'service_type.remind_configuration.objects.signer'},
    {value: '2', viewValue: 'service_type.remind_configuration.objects.approver'},
    {value: '3', viewValue: 'service_type.remind_configuration.objects.initialer'},
    {value: '5', viewValue: 'service_type.remind_configuration.objects.creator'},
  ];

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.onBtnCancelClick();
  }

  ngOnInit() {
    //Do check for configuration send sms when the contract is processed
    this.isCheckSendSMSInternalInFlow = this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0;

    if (this.isCheckSendSMSInternalInFlow || this.documents.isSendCustomerInFlow) {
      this.isCheckSendSMSInFlow = true;
    }
    //END Do check for configuration send sms when the contract is processed
    this.isCheckInternal = this.documents.sendInternalSign && this.documents.sendInternalSign.length > 0;

    if (this.isCheckInternal || this.documents.isSendCustomerSign) {
      this.isCheck = true;
    }


  }

  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => this.focusInput.first.nativeElement.focus(), 250);
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty || this.ngForm.touched) {
        this.isFormChanging = true;
      }
    });
  }

  onBtnCancelClick() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.ngForm.resetForm();
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.ngForm.resetForm();
      this.dialogRef.close();
    }
  }

  createOrEditGroupDocument() {
    // console.log(this.documents)
    if (!this.documents.id) {
      this.documents.allowImage = true;
      this.documents.allowOtp = true;
      this.documents.checkCertNumber = false;
      this.documents.checkName = false;
      this.documents.checkOtp = false;
      // Do check for configuration send sms when the contract is processed
      if (!this.documents.isOnSMSInFlow) {
        this.documents.isOnSMSInFlow = false;
      }
      if (!this.documents.sendSMSInternalInFlow) {
        this.documents.sendSMSInternalInFlow = [];
      }
      if (!this.documents.isSendCustomerInFlow) {
        this.documents.isSendCustomerInFlow = false;
      }
      // END Do check for configuration send sms when the contract is processed

      if (!this.documents.isSendSmsSign) {
        this.documents.isSendSmsSign = false;
      }
      if (!this.documents.sendInternalSign) {
        this.documents.sendInternalSign = [];
      }
      if (!this.documents.isSendCustomerSign) {
        this.documents.isSendCustomerSign = false;
      }
      if (!this.documents.isOnPromptToSign) {
        this.documents.isOnPromptToSign = false;
      }
      if (!this.documents.isSendSmsExpireContract) {
        this.documents.isSendSmsExpireContract = false;
      }
      if (!this.documents.isOnNotifyExpireContract) {
        this.documents.isOnNotifyExpireContract = false;
      }
    }
    const _clone = JSON.parse(JSON.stringify(this.documents));
    if (_clone.sendSMSInternalInFlow && _clone.sendSMSInternalInFlow.length > 0) {
      _clone.sendSMSInternalInFlow = _clone.sendSMSInternalInFlow.join(',');
    }
    if (_clone.sendInternalSign && _clone.sendInternalSign.length > 0) {
      _clone.sendInternalSign = _clone.sendInternalSign.join(',');
    }
    if (_clone.id) {
      this.serviceTypeService.updateServiceTypes(_clone, (err) => {
      }).subscribe((res) => {
        if (res.success) {
          this.show = false;
          this.toastr.success(this.message.getMessage('messages.update_success'));
          this.dialogRef.close();
          this.createSuccess.next();
        } else {
          if (res.data) {
            if (res.data.field === 'code') {
              this.focusCode.first.nativeElement.focus();
            }
            if (res.data.field === 'name') {
              this.focusInput.first.nativeElement.focus();
            }
          }
          this.toastr.error(res.data ? res.data.error : res.message);
        }
      });
    } else {
      this.serviceTypeService.createServiceTypes(_clone, (err) => {
      }).subscribe((res) => {
        if (res.success) {
          this.show = false;
          this.toastr.success(this.message.getMessage('messages.add_success'));
          this.dialogRef.close();
          this.createSuccess.next();
        } else {
          if (res.data) {
            if (res.data.field === 'code') {
              this.focusCode.first.nativeElement.focus();
            }
            if (res.data.field === 'name') {
              this.focusInput.first.nativeElement.focus();
            }
          }
          this.toastr.error(res.data ? res.data.error : res.message);
        }
      }, error => {
        this.toastr.error(error.message ? error.message : error);
      });
    }
    return false;
  }

  formChangingCheckInternalRemindEvent() {
    this.isFormChanging = true;

    this.isCheckInternal = this.documents.sendInternalSign && this.documents.sendInternalSign.length > 0;
    if (this.isCheckInternal || this.documents.isSendCustomerSign) {
      this.isCheck = true;
    }
  }

  formChangingCheckSendSMSInternalInFlowEvent() {
    this.isFormChanging = true;
    this.isCheckSendSMSInternalInFlow = this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0;
    if (this.isCheckSendSMSInternalInFlow || this.documents.isSendCustomerInFlow) {
      this.isCheckSendSMSInFlow = true;
    }
  }

  private onAddCustomerError(rs: any) {
    if (!rs.success) {
      switch (rs.code) {
        case '0x001508':
          this.toastr.error(rs.message);
          break;
        case '0x00117':
          // this.taxNoExistingHanlder();
          break;
      }
    }
  }

  checkInternal(): void {
    this.isClick = true;
    this.isFormChanging = true;
    if (this.documents.sendInternalSign && this.documents.sendInternalSign.length > 0) {
      this.documents.sendInternalSign = [];
      this.isCheckInternal = false;
    } else {
      this.documents.sendInternalSign = ['1', '2', '3'];
      this.isCheckInternal = true;
    }
    this.isCheck = this.isCheckInternal === true || this.documents.isSendCustomerSign === true;
    // console.log(this.isCheck)
  }

  checkCustomer(): void {
    this.isClick = true;
    this.documents.isSendCustomerSign = !this.documents.isSendCustomerSign;
    // console.log(this.documents.isSendCustomerSign)
    this.isFormChanging = true;
    this.isCheck = this.isCheckInternal === true || this.documents.isSendCustomerSign === true;
    // console.log(this.isCheck)
  }

  // -- For configuration sending sms when a contract is processed or not
  checkSendSMSInternalInFlow(): void {
    this.isClickSendSMSInFlow = true;
    this.isFormChanging = true;
    if (this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0) {
      this.documents.sendSMSInternalInFlow = [];
      this.isCheckSendSMSInternalInFlow = false;
    } else {
      this.documents.sendSMSInternalInFlow = ['1', '2', '3', '5'];
      this.isCheckSendSMSInternalInFlow = true;
    }
    this.isCheckSendSMSInFlow = this.isCheckSendSMSInternalInFlow === true || this.documents.isSendCustomerInFlow === true;
  }

  checkSendSMSCustomerInFlow(): void {
    this.isClickSendSMSInFlow = true;
    this.documents.isSendCustomerInFlow = !this.documents.isSendCustomerInFlow;
    this.isFormChanging = true;
    this.isCheckSendSMSInFlow = this.isCheckSendSMSInternalInFlow === true || this.documents.isSendCustomerInFlow === true;
  }

  // toggleAllSelection() {
  //   if (this.allSelected) {
  //     this.select.options.forEach((item: MatOption) => item.select());
  //     this.documents.sendInternalSign = "1,2,3"
  //   } else {
  //     this.select.options.forEach((item: MatOption) => item.deselect());
  //     this.documents.sendInternalSign = ""
  //   }
  // }

  // optionClick() {
  //   let newStatus = true;
  //   let flag = '';
  //   this.select.options.forEach((item: MatOption) => {
  //     if (!item.selected) {
  //       newStatus = false;
  //     } else {
  //       flag = flag + ',' + item.value
  //     }
  //   });
  //
  //   this.documents.sendInternalSign = flag.substring(1)
  //   // this.allSelected = newStatus;
  // }

  clickChangeSMSConfiguration(data) {
    this.documents.isOnSMSInFlow = data;
    if (this.documents.isOnSMSInFlow === false) {
      this.isFormChanging = true;
      this.documents.sendSMSInternalInFlow = [];
      this.documents.isSendCustomerInFlow = false;
    }
  }

  clickSend(data) {
    if (!(this.documents.id === null || this.documents.id === undefined)) {
      if (data === false && this.documents.isOnPromptToSign && this.isOnRemindSignContract) {
        const dialogRe = this.dialog.open(WarningComponent, {
          width: '600px',
          data: this.commonService.format(this.message.getMessage('messages.confirm_off_sign_contract_config'), this.documents.name)
        });
        dialogRe.afterClosed().subscribe(rs => {
          if (rs) {
            this.documents.isOnPromptToSign = data;
            if (this.documents.isOnPromptToSign === false) {
              this.documents.isSendSmsSign = false;
              this.documents.sendInternalSign = [];
              this.documents.cycleSendSign = null;
              this.documents.isSendCustomerSign = false;
            }
          } else {
            this.documents.isOnPromptToSign = true;
            document.getElementById('on-button-button').click();
          }
        });
      } else {
        this.documents.isOnPromptToSign = data;
      }
    } else {
      this.documents.isOnPromptToSign = data;
      if (this.documents.isOnPromptToSign === false) {
        this.documents.isSendSmsSign = false;
        this.documents.sendInternalSign = [];
        this.documents.cycleSendSign = null;
        this.documents.isSendCustomerSign = false;
      }
    }
  }

  clickSendExpire(data) {
    // console.log(this.documents)
    this.documents.isOnNotifyExpireContract = data;
    if (this.documents.isOnNotifyExpireContract === false) {
      this.documents.isSendSmsExpireContract = false;
      this.documents.timeNotifyBeforeExpire = null;
      this.documents.cycleNotifyExpireContract = null;
    }
  }

}

export class Document {
  id: number;
  name: string;
  note: string;
  code: string;
  allowOtp: boolean;
  allowImage: boolean;
  checkCertNumber: boolean;
  checkName: boolean;
  checkOtp: boolean;
  isSendSmsSign: boolean;
  sendInternalSign: any;
  isSendCustomerSign: boolean;
  cycleSendSign: number;
  isOnPromptToSign = false;
  isOnNotifyExpireContract: boolean;
  isSendSmsExpireContract: boolean;
  timeNotifyBeforeExpire: number;
  cycleNotifyExpireContract: number;
  isOnSMSInFlow = false;
  sendSMSInternalInFlow: any;
  isSendCustomerInFlow: boolean;
}
